import { render } from "./SoloSlider.vue?vue&type=template&id=4d2a063a"
import script from "./SoloSlider.vue?vue&type=script&lang=js"
export * from "./SoloSlider.vue?vue&type=script&lang=js"

import "./SoloSlider.vue?vue&type=style&index=0&id=4d2a063a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__